/**
 * @tabler/icons-react v2.47.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconBrandPrintables = createReactComponent("brand-printables", "IconBrandPrintables", [
  [
    "path",
    { d: "M6 21l12 -7v-7.5l-6 -3.5l-6 3.5l6 3.5v7.5l-6 -3.5z", key: "svg-0" }
  ]
]);

export { IconBrandPrintables as default };
//# sourceMappingURL=IconBrandPrintables.js.map
